export default __webpack_public_path__ + "static/media/proyek-traktor.fa99e9ce.png";